import React from "react";
import { FaDesktop, FaMobileAlt, FaAndroid, FaUserTie, FaShoppingCart, FaGlobe } from "react-icons/fa";
import { FaFileExport } from "react-icons/fa6";
import { TagComponent } from "../Tabs";

const ExportingOrders = () => {

    return (
        <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">



            <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
                <FaFileExport className="text-4xl text-theme-logo-color mr-3" />
                <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Order Actions</h1>
            </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="pink" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      
            {/* Intro Text */}
            <div className="bg-gray-50 p-6 rounded-2xl ">
                <p className="text-gray-700 text-start text-base leading-relaxed ">
                    Orders can be saved in JSON or XML format, allowing you to import them into your existing software seamlessly.
                </p>
            </div>


            <div className="bg-gray-50 p-6 rounded-2xl ">
                <p className="text-gray-700 text-start text-base leading-relaxed ">
                    The order preview page also provides direct links to download the order as a PDF or XLS file. Click the links below to see how accurately the order is displayed in both formats.
                </p>
            </div>

            <div className="bg-red-100 text-red-600 p-4 rounded-lg border border-red-300 text-start">
                Ensure that each Product (SKU) has a defined 'Product ID' and each buyer has a 'Buyer ID' so that exported orders can be properly used in your existing software.
            </div>

        </div>
    );
};

export default ExportingOrders;